export default __webpack_public_path__ + "fe917d551acda3c42dd808c9d2bd99c5.png";